// extracted by mini-css-extract-plugin
module.exports = {"emptyTitle":"SalesPagesHome_emptyTitle__3AYUm","cardsContainer":"SalesPagesHome_cardsContainer__L7SoK"};